document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ibb025-tabs-nav').forEach(function(tabContainer) {
        const blockRoot = tabContainer.closest('.ibb025-main') || document;
        const tabItems = Array.from(tabContainer.querySelectorAll('.ibb025-tab'));
        if (!tabItems.length) return;

        const contents = Array.from(blockRoot.querySelectorAll('.ibb025-content-container'));
        let activeTabItem = null;

        function activateTab(tabItem) {
            if (!tabItem || tabItem === activeTabItem) return;

            if (activeTabItem) {
                activeTabItem.classList.remove('active');
                const previousContent = blockRoot.querySelector(`.ibb025-content-container[data-ibb025-tab="${activeTabItem.dataset.ibb025Tab}"]`);
                if (previousContent) previousContent.style.display = 'none';
            }

            activeTabItem = tabItem;
            activeTabItem.classList.add('active');

            const nextContent = blockRoot.querySelector(`.ibb025-content-container[data-ibb025-tab="${activeTabItem.dataset.ibb025Tab}"]`);
            if (nextContent) nextContent.style.display = '';
        }

        contents.forEach(content => {
            content.style.display = 'none';
        });

        const initialTabItem = tabItems.find(tabItem => {
            const link = tabItem.querySelector('.ibb025-tab-link');
            return link && link.getAttribute('href') === location.hash;
        }) || tabItems[0];
        activateTab(initialTabItem);

        // Handle mouseover for tab switching
        tabContainer.addEventListener('mouseover', function(event) {
            const newTabItem = event.target.closest('.ibb025-tab');
            if (newTabItem && tabContainer.contains(newTabItem)) {
                activateTab(newTabItem);
            }
        });
    });
});